import classnames from "classnames/bind";
import styles from "./TogglePill.module.scss";
let cx = classnames.bind(styles);

const TogglePill = ({ className, options }) => {
  return (
    <div className={cx(styles.Container, className)}>
      {options?.map((option, index) => (
        <div
          key={index}
          className={cx(styles.Tab, {
            [styles.Selected]: option["selected"],
            [styles.Left]: index === 0,
            [styles.Right]: index === options.length - 1,
          })}
          onClick={option["onSelect"]}>
          {option.label}
        </div>
      ))}
    </div>
  );
};

export default TogglePill;
